import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsGetMunicipalities_municipalityIdSolar_connectionsOptions = z.any()
export type TagsGetMunicipalities_municipalityIdSolar_connectionsOptions = z.infer<typeof tagsGetMunicipalities_municipalityIdSolar_connectionsOptions>

export const paramsGetMunicipalities_municipalityIdSolar_connectionsOptions = z.object({ "municipalityId": z.string().uuid() })
export type ParamsGetMunicipalities_municipalityIdSolar_connectionsOptions = z.infer<typeof paramsGetMunicipalities_municipalityIdSolar_connectionsOptions>

export const querystringGetMunicipalities_municipalityIdSolar_connectionsOptions = z.object({})
export type QuerystringGetMunicipalities_municipalityIdSolar_connectionsOptions = z.infer<typeof querystringGetMunicipalities_municipalityIdSolar_connectionsOptions>

export const responseGetMunicipalities_municipalityIdSolar_connectionsOptions = z.object({ "payload": z.object({ "municipalities": z.array(z.object({ "id": z.string(), "name": z.string() })), "collectionPoints": z.array(z.object({ "id": z.string(), "name": z.string(), "buildingId": z.string(), "buildingName": z.string(), "buildingGroupNames": z.array(z.string()) })) }).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponseGetMunicipalities_municipalityIdSolar_connectionsOptions = z.infer<typeof responseGetMunicipalities_municipalityIdSolar_connectionsOptions>

interface IGetMunicipalities_municipalityIdSolar_connectionsOptions extends BaseMethodType {
  tags: TagsGetMunicipalities_municipalityIdSolar_connectionsOptions,
  params: ParamsGetMunicipalities_municipalityIdSolar_connectionsOptions,
  querystring: QuerystringGetMunicipalities_municipalityIdSolar_connectionsOptions,
  response: ResponseGetMunicipalities_municipalityIdSolar_connectionsOptions
}
export const URL = '/municipalities/:municipalityId/solar-connections/options'
export const validation = {
  get: {
    tags: tagsGetMunicipalities_municipalityIdSolar_connectionsOptions,
    params: paramsGetMunicipalities_municipalityIdSolar_connectionsOptions,
    querystring: querystringGetMunicipalities_municipalityIdSolar_connectionsOptions,
    response: responseGetMunicipalities_municipalityIdSolar_connectionsOptions
  }
}
export interface Municipalities_municipalityIdSolar_connectionsOptions extends BaseRouteType {
  get: IGetMunicipalities_municipalityIdSolar_connectionsOptions
}